// Icônes + libellés pour chaque type d'acteur (Phosphor Icons React).
import {
  Handshake, Users, ClockCounterClockwise, Handshake as HandshakeAlt,
  Megaphone, Buildings, GraduationCap, Coin, Storefront, Toolbox,
  UserFocus,
} from '@phosphor-icons/react';

export const TYPE_ACTEUR = [
  { value: 'prospect',                         label: 'Prospect',                          Icon: UserFocus,               color: '#2D5A4C' },
  { value: 'membre',                           label: 'Membre',                            Icon: Users,                   color: '#2D5A4C' },
  { value: 'ancien_membre',                    label: 'Ancien membre',                     Icon: ClockCounterClockwise,   color: '#8A9B93' },
  { value: 'partenaire',                       label: 'Partenaire',                        Icon: HandshakeAlt,            color: '#E8A365' },
  { value: 'prescripteur',                     label: 'Prescripteur',                      Icon: Megaphone,               color: '#62A8D4' },
  { value: 'collectivite',                     label: 'Collectivité',                      Icon: Buildings,               color: '#D47A62' },
  { value: 'expert',                           label: 'Expert',                            Icon: GraduationCap,           color: '#7A5CD4' },
  { value: 'associe_cooperateur_pp',           label: 'Associé coopérateur PP',            Icon: Coin,                    color: '#2D5A4C' },
  { value: 'associe_cooperateur_prestataire',  label: 'Associé coopérateur Prestataire',   Icon: Handshake,               color: '#2D5A4C' },
  { value: 'prestataire_tiers',                label: 'Prestataire tiers',                 Icon: Storefront,              color: '#E8A365' },
];

export const findTypeActeur = (value) => TYPE_ACTEUR.find(t => t.value === value);

// Secteurs d'activité ESS Outre-mer (multi-sélection)
export const SECTEURS = [
  { value: 'agriculture_peche',       label: 'Agriculture / Pêche' },
  { value: 'aquaculture',             label: 'Aquaculture' },
  { value: 'artisanat',               label: 'Artisanat' },
  { value: 'btp_habitat',             label: 'BTP / Habitat' },
  { value: 'commerce',                label: 'Commerce' },
  { value: 'industrie',               label: 'Industrie' },
  { value: 'numerique',               label: 'Numérique / Tech' },
  { value: 'tourisme',                label: 'Tourisme' },
  { value: 'sante_social',            label: 'Santé / Social' },
  { value: 'education_formation',     label: 'Éducation / Formation' },
  { value: 'culture_patrimoine',      label: 'Culture / Patrimoine' },
  { value: 'environnement',           label: 'Environnement / Économie circulaire' },
  { value: 'services_personnes',      label: 'Services aux personnes' },
  { value: 'services_entreprises',    label: 'Services aux entreprises' },
  { value: 'insertion_emploi',        label: 'Insertion / Emploi' },
  { value: 'alimentation',            label: 'Alimentation' },
  { value: 'transport',               label: 'Transport' },
  { value: 'energie',                 label: 'Énergie' },
  { value: 'finance_solidaire',       label: 'Finance solidaire' },
  { value: 'autre',                   label: 'Autre' },
];

export const findSecteur = (value) => SECTEURS.find(s => s.value === value);
